import { t } from "@redotech/redo-i18n";
import { Condition } from "@redotech/redo-return-core-common/return-flow/condition";
import { CONDITION_NAMES } from "@redotech/redo-return-core-common/return-flow/condition-names";
import {
  fulfillmentWithinFromModel,
  validateFulfillmentWithinCondition,
  type FulfillmentWithinState,
} from "@redotech/redo-return-core-common/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const FULFILLMENT_WITHIN = (
  Details: React.ComponentType<
    ConditionTypeDetailsProps<FulfillmentWithinState>
  >,
): ConditionType<FulfillmentWithinState, Condition.FulfillmentPeriod> => ({
  name: CONDITION_NAMES[Condition.FULFILLMENT_WITHIN],
  description(state) {
    return t("Within {{count}} days of fulfillment", { count: +state });
  },
  Details(props: ConditionTypeDetailsProps<FulfillmentWithinState>) {
    return React.createElement(Details, props);
  },
  empty: String(30),
  fromModel(model) {
    return fulfillmentWithinFromModel(model);
  },
  toModel(state) {
    return {
      type: Condition.FULFILLMENT_WITHIN,
      duration: Temporal.Duration.from({ days: +state }),
    };
  },
  valid(state: string) {
    return validateFulfillmentWithinCondition(state).valid;
  },
});
